import GuardComponent from "./GuardComponent";

export default GuardComponent;
